'use strict';

module.exports = function isArrayish(obj) {
	if (!obj || typeof obj === 'string') {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && (obj.splice instanceof Function ||
			(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
};



//////////////////
// WEBPACK FOOTER
// ./~/simple-swizzle/~/is-arrayish/index.js
// module id = 1423
// module chunks = 114276838955818